import { render, staticRenderFns } from "./prenatalDetail.vue?vue&type=template&id=96e51418&scoped=true"
import script from "./prenatalDetail.vue?vue&type=script&lang=js"
export * from "./prenatalDetail.vue?vue&type=script&lang=js"
import style0 from "./prenatalDetail.vue?vue&type=style&index=0&id=96e51418&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e51418",
  null
  
)

export default component.exports